<template>
  <div class="shopOrder">
    <div class="shopList" v-for="(shop, index) of shopsData" :key="index">
      <!-- <div class="shopName">店铺：{{shop.shopName}}</div> -->
      <div class="orderList">
        <div class="orderItem">
          <div class="commodity itemBox">
            <img :src="shop.productInfo.image" :alt="shop.productInfo.storeName+shop.productInfo.attribute">
            <span>{{shop.productInfo.storeName}}{{shop.productInfo.attribute}}</span>
          </div>
          <div class="attributes itemBox">
            <span>{{shop.productInfo.attrInfo.sku}}</span>
            <!-- <span>{{shop.value}}</span> -->
          </div>
          <div class="unitPrice itemBox">￥{{shop.truePrice}}</div>
          <div class="numberBox itemBox">{{shop.cartNum}}</div>
<!--          <div class="discountBox itemBox">-->
<!--            <el-select v-model="order.discountName" placeholder="请选择">-->
<!--              <el-option-->
<!--                v-for="yhItem in order.discountList"-->
<!--                :key="yhItem.value"-->
<!--                :label="yhItem.label"-->
<!--                :value="yhItem.label">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </div>-->
          <div class="totalBox itemBox">￥{{shop.truePrice*shop.cartNum}}</div>
        </div>
      </div>
<!--      <div class="remarksBox">-->
<!--        <div class="remarksInfo">-->
<!--          <el-input-->
<!--            type="textarea"-->
<!--            :rows="2"-->
<!--            resize="none"-->
<!--            placeholder="如有其他要求，请备注。"-->
<!--            v-model="shop.remarksInfo">-->
<!--          </el-input>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="orderTotalBox">-->
<!--        <div class="shippingBox">运费：{{shop.productInfo.postage> 0?shop.productInfo.postage:"免运费"}}</div>-->
<!--        <div class="orderTotalBox">订单合计：<b>￥{{shop.truePrice * shop.cartNum}}</b></div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'shopOrder',
  props: {
    shopsData: Array
  },
  data () {
    return {
      shopData: [
        {
          shopName: '店铺：有钱吗？您就买？',
          id: 1,
          remarksInfo: '',
          shopDiscount: '',
          shipping: '￥20',
          orderTotal: '￥9030',
          shopDiscountList: [
            {
              id: 1,
              label: '优惠1',
              value: '120'
            },
            {
              id: 2,
              label: '优惠1',
              value: '120'
            },
            {
              id: 3,
              label: '优惠1',
              value: '120'
            }
          ],
          orderList: [
            {
              id: 1,
              avatar: require('../../../static/image/storeImg@2x.png'),
              title: '韩国ins敲颜色炒鸡好看的宽松chic条纹长袖T恤',
              color: '绿色',
              size: 'XL',
              unitPrice: '￥1000',
              number: 5,
              discountList: [
                {
                  label: '已省190元：狂欢大促',
                  value: '1'
                },
                {
                  label: '已省110元：狂欢大促',
                  value: '2'
                },
                {
                  label: '已省80元：狂欢大促',
                  value: '3'
                }
              ],
              discountValue: '1',
              discountName: '',
              total: '￥1000'
            },
            {
              id: 2,
              avatar: require('../../../static/image/storeImg@2x.png'),
              title: '韩国ins敲颜色炒鸡好看的宽松chic条纹长袖T恤',
              color: '绿色',
              size: 'XL',
              unitPrice: '￥1000',
              number: 5,
              discountList: [
                {
                  label: '已省190元：狂欢大促',
                  value: '1'
                },
                {
                  label: '已省110元：狂欢大促',
                  value: '2'
                },
                {
                  label: '已省80元：狂欢大促',
                  value: '3'
                }
              ],
              discountValue: '1',
              discountName: '',
              total: '￥1000'
            },
            {
              id: 3,
              avatar: require('../../../static/image/storeImg@2x.png'),
              title: '',
              color: '绿色',
              size: 'XL',
              unitPrice: '￥1000',
              number: 5,
              discountList: [
                {
                  label: '已省190元：狂欢大促',
                  value: '1'
                },
                {
                  label: '已省110元：狂欢大促',
                  value: '2'
                },
                {
                  label: '已省80元：狂欢大促',
                  value: '3'
                }
              ],
              discountValue: '1',
              discountName: '',
              total: '￥1000'
            }
          ]
        },
        {
          shopName: '店铺：有钱吗？您就买？22',
          id: 2,
          orderList: [
            {
              id: 1,
              avatar: require('../../../static/image/storeImg@2x.png'),
              title: '韩国ins敲颜色炒鸡好看的宽松chic条纹长袖T恤',
              color: '绿色',
              size: 'XL',
              unitPrice: '￥1000',
              number: 5,
              discountList: [
                {
                  label: '已省190元：狂欢大促',
                  value: '1'
                },
                {
                  label: '已省110元：狂欢大促',
                  value: '2'
                },
                {
                  label: '已省80元：狂欢大促',
                  value: '3'
                }
              ],
              discountValue: '1',
              discountName: '',
              total: '￥1000'
            },
            {
              id: 2,
              avatar: require('../../../static/image/storeImg@2x.png'),
              title: '韩国ins敲颜色炒鸡好看的宽松chic条纹长袖T恤',
              color: '绿色',
              size: 'XL',
              unitPrice: '￥1000',
              number: 5,
              discountList: [
                {
                  label: '已省190元：狂欢大促',
                  value: '1'
                },
                {
                  label: '已省110元：狂欢大促',
                  value: '2'
                },
                {
                  label: '已省80元：狂欢大促',
                  value: '3'
                }
              ],
              discountValue: '1',
              discountName: '',
              total: '￥1000'
            },
            {
              id: 3,
              avatar: require('../../../static/image/storeImg@2x.png'),
              title: '',
              color: '绿色',
              size: 'XL',
              unitPrice: '￥1000',
              number: 5,
              discountList: [
                {
                  label: '已省190元：狂欢大促',
                  value: '1'
                },
                {
                  label: '已省110元：狂欢大促',
                  value: '2'
                },
                {
                  label: '已省80元：狂欢大促',
                  value: '3'
                }
              ],
              discountValue: '1',
              discountName: '',
              total: '￥1000'
            }
          ]
        }
      ]
    }
  },
  created(){
		console.log('----',this.shopsData)
  }
}
</script>

<style lang="scss" scoped>
.shopOrder {
  .shopName {
    padding-left: 20px;
    margin-bottom: 30px;
    color: #333333;
    font-size: 16px;
  }
  .orderList {
    width: 100%;
    .orderItem {
      width: 100%;
      display: flex;
      border: 1px solid #E5E5E5;
      border-bottom: none;
      padding: 15px 0;
      box-sizing: border-box;
      .itemBox {
        color: #333333;
        font-size: 16px;
        text-align: center;
      }
      .commodity {
        width: 40%;
        display: flex;
        img {
          width: 80px;
          height: 80px;
          margin-left: 15px;
        }
        span {
          width: 320px;
          margin-left: 30px;
          text-align: left;
        }
      }
      .attributes {
        width: 20%;
        text-align: left;
        color: #999999;
        font-size: 16px;
        span {
          display: block;
          margin-bottom: 5px;
        }
      }
      .unitPrice {
        width: 15%;
        text-align: center;
      }
      .numberBox {
        width: 15%;
        text-align: center;
      }
      .discountBox {
        width: 20%;
        display: flex;
        justify-content: center;
        color: #666666;
        >>> .el-select {
          width: 200px;
          .el-input__inner {
            height: 34px;
            line-height: 34px;
          }
        }
      }
      .totalBox {
        width: 10%;
        text-align: center;
        color: $mainColor;
        font-weight: bold;
      }
    }
    .orderItem:last-child {
      border-bottom: 1px solid #E5E5E5;
    }
  }
  .remarksBox {
    display: flex;
    background: #F7F7F7;
    padding: 25px 35px;
    .remarksInfo {
      width: 100%;
      >>> .el-textarea__inner {
        width: 100%;
        height: 84px;
      }
    }
    .selectBox {
      margin-left: 70px;
      label {
        color: #666666;
        font-size: 16px;
        font-weight: normal;
      }
    }
    .shopTotal {
      color: $mainColor;
      flex: 1;
      text-align: right;
    }
  }
  .shopList {
    .orderTotalBox {
      margin-top: 20px;
      text-align: right;
      .shippingBox {
        color: #333333;
        font-size: 14px;
      }
      .orderTotalBox {
        font-size: 14px;
        color: #333333;
        b {
          color: $mainColor;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderInfo/shopOrder.vue